import { Link } from 'react-router-dom'
import { arbetsomraden, lektionerForArbetsomrade, lektionsord } from '../lib/lektionsplanering'
import { kapitelIndex } from '../lib/content'
import { useSidTitel } from '../lib/seo'

export default function LararhandledningOversikt() {
  useSidTitel('Lärarhandledning och lektionsplanering')
  // Räkna de lektioner som faktiskt finns i stället för det planerade antalet —
  // siffran på sidan ska aldrig kunna påstå mer än vad som är skrivet.
  const antalPerAo = new Map(arbetsomraden.map((ao) => [ao.id, lektionerForArbetsomrade(ao.id).length]))
  const totalt = [...antalPerAo.values()].reduce((s, n) => s + n, 0)

  return (
    <div className="wrap">
      <section className="hero hero-larare">
        <span className="hero-etikett hero-etikett-larare">För lärare</span>
        <h1>Lärarhandledning och lektionsplanering</h1>
        <p>
          Kursen är indelad i {arbetsomraden.length} arbetsområden. Varje arbetsområde har en
          lärarhandledning med tema, examination och förberedelser, och en serie lektioner
          uppbyggda av återanvändbara moduler.
        </p>
      </section>

      <section aria-labelledby="ao-rubrik">
        <h2 className="sektionsrubrik" id="ao-rubrik">Arbetsområden</h2>
        <p className="sektionsingress">
          Hela kursen omfattar {totalt} {lektionsord(totalt)}.
        </p>
        <div className="kapitelrutnat">
          {arbetsomraden.map((ao) => {
            const kapitelTitlar = ao.kopplade_kapitel
              .map((id) => kapitelIndex.find((k) => k.id === id)?.titel)
              .filter(Boolean)
            return (
              <Link key={ao.id} to={`/lararhandledning/${ao.id}`} className="kapitelkort ao-kort">
                <span className="chip chip-las">
                  {antalPerAo.get(ao.id)} {lektionsord(antalPerAo.get(ao.id) ?? 0)}
                </span>
                <span className="kapitelkort-nr">ARBETSOMRÅDE {ao.ordning}</span>
                <h3>{ao.titel}</h3>
                <p className="ao-kort-kapitel">Kapitel: {kapitelTitlar.join(', ')}</p>
              </Link>
            )
          })}
        </div>
        <p className="lararhandledning-blockbibliotek-lank">
          <Link to="/lararhandledning/blockbibliotek">Blockbiblioteket →</Link>
          <span> Lektionernas återanvändbara byggblock, med utbytesalternativ.</span>
        </p>
      </section>
    </div>
  )
}
